import(/* webpackMode: "eager" */ "/builds/src/app/(events)/events/subs-direct-change/index/page.jsx");
